
import {TIMEZONES} from 'consts/timezones'

export default {
  props: {
    store: {type: Object, required: true}
  },
  emits: ['update'],
  data() {
    return {
      value: this.store.timezone || 'UTC',
      options: TIMEZONES.map((item) => {
        return {
          label: item,
          value: item
        }
      })
    }
  },
  computed: {
    my_store() {
      return this.store
    }
  },
  watch: {
    value(val) {
      this.my_store._state.timezone = val
      this.$emit('update')
    }
  },
}
